<template>
  <div class="spotlight-inner-wrapper">
    <div class="confirmation-hero text-center mb-5">
      <h2>{{ $t('message.spotlight.sxm.confirmation.title') }}</h2>
      <img class="my-3" :src="require(`@/assets/speech-balloon.svg`)" alt="" />
      <p>{{ $t('message.spotlight.sxm.confirmation.text') }}</p>
    </div>
    <CTA />
  </div>
</template>

<script>
import CTA from '@/components/ProductCTAs.vue';

export default {
  name: 'Confirmation',
  components: {
    CTA,
  },
};
</script>

<style scoped></style>
